// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/GlobalPriceModal/GlobalPriceModal.css
// module id = 1671
// module chunks = 0